// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__0HwOj","tab":"styles_tab__kSwiT","label":"styles_label__kLyY9"};